module.exports = __webpack_public_path__ + "img/work-examples-bkg.png";